export default __webpack_public_path__ + "static/media/nycitycounsil.018bceca.jpg";